import comp from '../components/barrel';
import U from '../js/utils';

export default {
  async prepare() {
    this.recipe.methods.push(await O.mPOST('communal/provinces'));
    this.recipe.methods.push(await O.mPOST('communal/div-branches'));
    this.recipe.methods.push(await O.mPOST('communal/org-branches'));
    this.recipe.methods.push(await O.mPOST('communal/divisions'));
    this.recipe.methods.push(await O.mPOST('communal/organisation-types'));
  },
  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(res) {
    this.provincesData = res['communal/provinces'].data;
    this.divBranchesData = res['communal/div-branches'].data;
    this.orgBranchesData = res['communal/org-branches'].data;
    this.orgTypesData = res['communal/organisation-types'].data;
    this.divisionsData = res['communal/divisions'].data.divisions;

    const inputForm = U.id('org-form');
    inputForm.innerHTML = '';

    // =====================================
    // ORGANISATION DETAILS
    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-3');
    grid1.id = 'newItem';

    const divisionDD = await comp.select_v2({elID: 'companyDD', ddData: this.divisionsData, valueDataName: 'division_uuid', textDataName: 'short_text', labelName: 'Company', requiredYN: 1, onchange: 'thsPage.showCompanyBranch()'});
    const compBranchDiv = U.divAtt('div', 'id', 'compBranchDiv');
    const orgTypeDD = await comp.select_v2({elID: 'orgTypeDD', ddData: this.orgTypesData, valueDataName: 'org_type_uuid', textDataName: 'short_text', labelName: 'Organisation Type', requiredYN: 1});
    const orgName = await comp.inputText('orgName', '', 'Organisation Name', 1);
    const regNumber = await comp.inputText('regNumber', '', 'Registeration Number', 1);
    const fspDiv = U.divAtt('div', 'id', 'fspDiv');

    grid1.appendChild(divisionDD);
    grid1.appendChild(compBranchDiv);
    grid1.appendChild(orgTypeDD);
    grid1.appendChild(orgName);
    grid1.appendChild(regNumber);
    grid1.appendChild(fspDiv);
    inputForm.appendChild(grid1);

    // =====================================
    // BUSINESS ADDRESS
    const bAddress = await comp.inputText(`bAddress`, '', 'Business Address', 1);
    inputForm.appendChild(bAddress);

    const grid2 = U.divAtt('div', 'class', 'res-grid-cols-3');
    grid2.id = 'newItemBusinessAddress';

    const bSuburb = await comp.inputText(`bSuburb`, '', 'Suburb', 1);
    const bTown = await comp.inputText(`bTown`, '', 'Town/City', 1);
    const bProvinceDD = await comp.select_v2({elID: 'bProvinceDD', ddData: this.provincesData, valueDataName: 'province_uuid', textDataName: 'long_text', labelName: 'Province', requiredYN: 1});
    const bArea = await comp.inputText(`bArea`, '', 'Area Code', 1);
    grid2.appendChild(bSuburb);
    grid2.appendChild(bTown);
    grid2.appendChild(bProvinceDD);
    grid2.appendChild(bArea);
    inputForm.appendChild(grid2);

    // =====================================
    // POSTAL ADDRESS
    const pAddress = await comp.inputText(`pAddress`, '', 'Postal Address', 1);
    inputForm.appendChild(pAddress);

    const grid3 = U.divAtt('div', 'class', 'res-grid-cols-3');
    grid3.id = 'newItemPostalAddress';

    const pSuburb = await comp.inputText(`pSuburb`, '', 'Suburb', 1);
    const pTown = await comp.inputText(`pTown`, '', 'Town/City', 1);
    const pProvinceDD = await comp.select_v2({elID: 'pProvinceDD', ddData: this.provincesData, valueDataName: 'province_uuid', textDataName: 'long_text', labelName: 'Province', requiredYN: 1});
    const pArea = await comp.inputText(`pArea`, '', 'Area Code', 1);
    grid3.appendChild(pSuburb);
    grid3.appendChild(pTown);
    grid3.appendChild(pProvinceDD);
    grid3.appendChild(pArea);
    inputForm.appendChild(grid3);

    const textarera = await comp.textarea('textarea', '', 'Notes', 0);
    inputForm.appendChild(textarera);

  },
  async showCompanyBranch() {
    const companyDD = U.id('companyDD').value;
    const grid1 = U.id('compBranchDiv');
    grid1.innerHTML = '';

    if (!companyDD) {
      return;
    }

    const filteredData = this.divBranchesData.filter((division) => division.division_uuid === companyDD);

    const compBranchDD = await comp.select_v2({elID: 'compBranchDD', ddData: filteredData, valueDataName: 'division_branch_uuid', textDataName: 'short_text', labelName: 'Employee company branch', requiredYN: 1});
    grid1.appendChild(compBranchDD);
  },
  async addOrg() {
    if (!(await U.validateForm('org-form'))) {
      return;
    }

    const vars = {};
    vars.company = U.id('companyDD').value;
    vars.companyBranch = U.id('compBranchDD').value;
    vars.orgType = U.id('orgTypeDD').value;
    vars.orgName = U.id('orgName').value;
    vars.regNumber = U.id('regNumber').value;

    vars.bAddress = U.id('bAddress').value;
    vars.bSuburb = U.id('bSuburb').value;
    vars.bTown = U.id('bTown').value;
    vars.bProvinceDD = U.id('bProvinceDD').value;
    vars.bArea = U.id('bArea').value;

    vars.pAddress = U.id('pAddress').value;
    vars.pSuburb = U.id('pSuburb').value;
    vars.pTown = U.id('pTown').value;
    vars.pProvinceDD = U.id('pProvinceDD').value;
    vars.pArea = U.id('pArea').value;

    vars.notes = U.id('textarea').value;

    O.PREP([await O.mPOST('organisation/ins-organisation', vars)])
      .then(async (res) => {
        const msg = res['organisation/ins-organisation'].status;
        comp.toast(msg);
        this.render();
      })
      .catch((err) => {
      });
  },
};
